import { TranslationFile } from 'i18n'
import { useTranslation } from 'react-i18next'

import appConfig from 'app.config'
import { IApplicationInformation } from 'interfaces/i-application-information'
import { MarketingChannel } from 'constants/enums/marketingChannels'

export const MarketingPreferenceFormUK = (data: IApplicationInformation) => {
	const { t } = useTranslation([
		TranslationFile.Translation,
		TranslationFile.Forms,
		TranslationFile.Countries,
	])

	return {
		fieldSetName: '',
		formName: 'MarketingPreferenceForm',
		collapsable: false,
		description: t('forms:MarketingPreferencesHeader'),
		show: true,
		visible: true,
		market: appConfig.country,
		fullSize: true,
		col: 12,
		controls: [
			{
				required: false,
				controlName: 'marketingPreferences',
				type: 'radio',
				customClass: 'verticalNoBorder',
				value: data?.contacts?.preferredContactType,
				description: t('forms:MarketingPreferencesDescription'),
				descriptionSubtext: t(
					'forms:MarketingPreferencesChannelsDescription',
				),
				options: [
					{
						value: MarketingChannel.Any,
						label: t('forms:MarketingChannelAny'),
					},
					{
						value: MarketingChannel.Email,
						label: t('forms:MarketingChannelEmail'),
					},
					{
						value: MarketingChannel.Letter,
						label: t('forms:MarketingChannelLetter'),
					},
					{
						value: MarketingChannel.Sms,
						label: t('forms:MarketingChannelSms'),
					},
					{
						value: MarketingChannel.Phone,
						label: t('forms:MarketingChannelPhone'),
					},
				],
				visible: true,
				col: 12,
			},
		],
	}
}
